import React from 'react';
import { WIZARD_STEPS } from './constants';

const WizardStepper = ({ currentStep }) => (
    <div className="wizard-stepper">
        {WIZARD_STEPS.map((step, i) => (
            <React.Fragment key={step.id}>
                <div className={`step-item ${currentStep >= step.id ? 'active' : ''}`}>
                    <div className="step-circle">{step.id}</div>
                    <span>{step.label}</span>
                </div>
                {i < WIZARD_STEPS.length - 1 && <div className="step-divider" />}
            </React.Fragment>
        ))}
    </div>
);

export default WizardStepper;
